import { fit as fitImage } from '../wixstatic/resizeImage';
var IMAGES_URL = 'https://static.wixstatic.com/';
export var getImageUrl = function (fileId, maxImageWidth, maxImageHeight) {
    var encodedFileId = encodeURIComponent(fileId);
    var url = "".concat(IMAGES_URL, "media/").concat(encodedFileId);
    if (maxImageWidth === undefined || maxImageHeight === undefined) {
        return url;
    }
    return fitImage(url, maxImageWidth, maxImageHeight);
};
export var getImageUrlByPath = function (imagePath) {
    return "".concat(IMAGES_URL).concat(imagePath);
};
//# sourceMappingURL=imageUrl.js.map